import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import ApplicationActualsEdit from '@/views/ApplicationActualsEdit.vue';
import ApplicationActualsList from '@/views/ApplicationActualsList.vue';
import AccountingSheetsList from '@/views/AccountingSheetsListPage.vue';
import RatesPage from '@/views/RatesPage.vue';
import RatesConflictsPage from '@/views/RatesConflictsPage.vue';
import EntityLoader from '@/views/EntityLoader.vue';
import Profile from '@/views/Profile.vue';
import ReportConstructor from '@/views/ReportConstructor.vue';
import OperationReport from '@/views/OperationReport.vue';
import PretensionsReport from '@/views/PretensionsReport.vue';
import ConfirmationOfCompletedWork from '@/views/ConfirmationOfCompletedWork.vue';
import Pretensions from '@/views/Pretensions.vue';
import PretensionPage from '@/views/PretensionPage.vue';
import FormationOfAccountingSheets from '@/views/FormationOfAccountingSheets.vue';
import AccountingSheetPage from '@/views/AccountingSheetPage.vue';
import ErrorPage from '@/views/ErrorPage.vue';
import isAuthSession from '@/middlewares/isAuthSession';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    children: [
      {
        path: 'entity/:entityName',
        name: 'Entity',
        component: EntityLoader,
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
      },
    ],
  },
  {
    path: '/application-edit-actual',
    name: 'ApplicationEditActual',
    component: ApplicationActualsEdit,
  },
  {
    path: '/application-actuals-list',
    name: 'ApplicationActualsList',
    component: ApplicationActualsList,
  },
  // {
  //   path: '/template',
  //   name: 'ApplicationTemplate',
  //   component: ApplicationTemplate,
  // },
  {
    path: '/rates',
    name: 'RatesPage',
    component: RatesPage,
  },
  {
    path: '/rates-conflicts',
    name: 'RatesConflictsPage',
    component: RatesConflictsPage,
  },
  {
    path: '/formation-of-accounting-sheets',
    name: 'FormationOfAccountingSheets',
    component: FormationOfAccountingSheets,
  },
  {
    path: '/accounting-sheets-list',
    name: 'AccountingSheetsList',
    component: AccountingSheetsList,
  },
  {
    path: '/confirmation-of-completed-work',
    name: 'ConfirmationOfCompletedWork',
    component: ConfirmationOfCompletedWork,
  },
  {
    path: '/report-constructor',
    name: 'ReportConstructor',
    component: ReportConstructor,
  },
  {
    path: '/operation-report',
    name: 'OperationReport',
    component: OperationReport,
  },
  {
    path: '/pretensions-report',
    name: 'PretensionsReport',
    component: PretensionsReport,
  },
  {
    path: '/accounting-sheet/:id',
    name: 'AccountingSheetPage',
    component: AccountingSheetPage,
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      layout: 'Auth',
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: () => import(/* webpackChunkName: "about" */ '../views/AccessDenied.vue'),
  },
  {
    path: '/pretensions',
    name: 'Pretensions',
    component: Pretensions,
  },
  {
    path: '/pretension/:id',
    name: 'PretensionPage',
    component: PretensionPage,
  },
  // {
  //   path: '/reports',
  //   name: 'Reports',
  //   component: Reports,
  // },
  {
    path: '/page-not-found',
    name: 'Error',
    component: ErrorPage,
  },
  {
    path: '*',
    redirect: '/page-not-found',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(isAuthSession);

export default router;
